import { Component, ViewChild } from '@angular/core';
import { ListaPulsantiMercatiComponent } from "../shared/lista-pulsanti-mercati/lista-pulsanti-mercati.component";
import { AsianboService } from 'src/app/services/asianbo.service';
import { TradingSystemGraficoWeeklyComponent } from '../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import { TradingSystemSummaryComponent } from '../shared/trading-system-summary/trading-system-summary.component';
import { FormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-asiabo-ct',
  standalone: true,
  imports: [ListaPulsantiMercatiComponent, HighchartsChartModule, TradingSystemGraficoWeeklyComponent,
    TradingSystemSummaryComponent, FormsModule, MdbFormsModule, MdbSelectModule,
    CommonModule
  ],
  templateUrl: './asiabo-ct.component.html',
  styleUrl: './asiabo-ct.component.scss'
})
export class AsiaboCtComponent {
  datiMercati: any[] = []
  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  mercati: any[] = []
  lottivar: boolean = false
  selezionato: any = null
  ts!: TradingSystemSummary
  tipoStorico: string = '09'
  storico: any[] = [
    { value: '09', label: 'Take Profit 09' },
    { value: '1', label: 'Take Profit 1' },
    { value: '13', label: 'Take Profit 1.3' },
    { value: '16', label: 'Take Profit 1.6' },
    { value: '26', label: 'Take Profit 2.6' }
  ]

  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartBuy') chartWeekBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartSell') chartWeekSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonth') chartMonth!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlyBuy') chartMonthlyBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlySell') chartMonthSell!: TradingSystemGraficoWeeklyComponent

  constructor(private serv: AsianboService) {

  }

  ngOnInit() {
    this.serv.getMarkets().subscribe((data: any) => {
      console.log(data)
      this.mercati = data.data//.filter((el: any) => el.tipo == 'Major' || el.tipo == 'Cross')
    })
  }

  selMarket(mkt: any) {
    console.log("Market selected:", mkt, this.tipoStorico);     
    let market = mkt.market
    this.selezionato = mkt
    this.serv.asiact_storico(mkt.market, this.tipoStorico).subscribe((data: any) => {
      if (data.res == 'ok') {
        console.log(data.data)
        data.data.map((el: any) => {
          el.ora = el.oraopen
          el.profit = parseFloat(el.profit)
        })
        this.datiMercati = data.data
        this.calcolaDati(this.datiMercati, market)
      }
    })
  }

  cambiaStorico(periodo: any) {
    this.tipoStorico = periodo
    console.log("Cambiato periodo storico a:", periodo);
    if(this.selezionato)
      this.selMarket(this.selezionato)
  }

  ricalcola(event: any) {
    console.log("Lotti variabili:", event.target.checked);
    if (event.target.checked) {
      let arr10 = this.datiMercati.slice(0, 10)
      let lotti  = arr10.reduce((acc: any, el: any) => {
        return acc + Math.abs(el.prezzoopen-el.stoploss) 
      }, 0)/10
      let prog = 0
      let newData =  this.datiMercati.map((el: any) => {
        let profit = el.profit *lotti/ Math.abs(el.prezzoopen-el.stoploss)
        return{...el, profit : profit ,progressivo : (prog += profit)}
      })
      this.calcolaDati(newData, this.selezionato.market)
    } else {
      this.calcolaDati(this.datiMercati, this.selezionato.market)
    }
  }

  calcolaDati(data: any, market: string) {
    this.chartWeek.caricaDati(data)
    this.chartWeekBuy.caricaDati(data.filter((el: any) => el.verso == 'buy'))
    this.chartWeekSell.caricaDati(data.filter((el: any) => el.verso == 'sell'))
    this.chartMonth.caricaDatiMese(data)
    this.chartMonthlyBuy.caricaDatiMese(data.filter((el: any) => el.verso == 'buy'))
    this.chartMonthSell.caricaDatiMese(data.filter((el: any) => el.verso == 'sell'))
    this.ts = new TradingSystemSummary().popolaDati(market, this.mercati.find((el: any) => el.market == market).pip, data)
    this.ts.spread = this.mercati.find((el: any) => el.market == market).spread
    this.aggiornaGrafico(data)
  }

  aggiornaGrafico(data: any) {
    let s1 = data.map((el: any) => [el.ora, parseFloat(el.progressivo)])
    let s2 = data.map((el: any) => [el.ora, parseFloat(el.prezzoclose)])
    var that = this
    this.chartOptions = {
      title: {
        text: 'Backtest ' + this.selezionato.market
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      series: [{
        name: 'Progressivo',
        data: s1,
        type: 'line',
        color: 'lime',
        turboThreshold: 4000
      }, {
        name: this.selezionato.market,
        data: s2,
        type: 'line',
        dashStyle: 'ShortDot',
        yAxis: 1,
        turboThreshold: 4000
      }],
      yAxis: [
        {
          title: {
            text: 'Progressivo'
          }
        },
        {
          title: {
            text: 'Cambio'
          },
          opposite: true
        }
      ],
      /* plotOptions: {
        series: {
          events:  {
            click: function (event) {
              window.aprimodal(data[event.point.x], s2, that, 'Operazione numero ' + event.point.x, event.point.x)              
            }
          }
        }
      }, */
    }
    this.updateFlag = true
  }

}
